import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "../style";

export const SeismicNatcatLegend = ({ customLegendStyle = legendStyle, howdenVersion }) => {
  const { t } = useTranslation();

  return (
    <div style={customLegendStyle}>
      <div>
        <b>{`${t("legend.seismicHowdenRisk")} ${howdenVersion}`}</b>
      </div>
      <div>
        <span style={legendItemStyle("#d7191c")}></span>
        10
      </div>
      <div>
        <span style={legendItemStyle("#e85b3b")}></span>9
      </div>
      <div>
        <span style={legendItemStyle("#f99d59")}></span>8
      </div>
      <div>
        <span style={legendItemStyle("#fec980")}></span>7
      </div>
      <div>
        <span style={legendItemStyle("#ffedaa")}></span>6
      </div>
      <div>
        <span style={legendItemStyle("#ecf7b9")}></span>5
      </div>
      <div>
        <span style={legendItemStyle("#c7e8ad")}></span>4
      </div>
      <div>
        <span style={legendItemStyle("#9dd3a6")}></span>3
      </div>
      <div>
        <span style={legendItemStyle("#64abb0")}></span>2
      </div>
      <div>
        <span style={legendItemStyle("#2b83ba")}></span>1
      </div>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          {howdenVersion === 1
            ? t("riskExposureMapExplained.seismicClassificationHowden")
            : t("riskExposureMapExplained.seismicClassificationHowden2")}
        </span>
      </div>
    </div>
  );
};
